let pending: Promise<void> | null = null;
let cancelled = false;
export class AdminMfaCancelledError extends Error {
  constructor() {
    super("Vérification de connexion annulée.");
  }
}
export function resetAdminMfaCancellation() {
  cancelled = false;
}
export function requireAdminMfa(): Promise<void> {
  if (cancelled) return Promise.reject(new AdminMfaCancelledError());
  if (pending) return pending;
  pending = new Promise<void>((resolve, reject) =>
    window.dispatchEvent(
      new CustomEvent("permio:admin-mfa", {
        detail: {
          resolve,
          reject: () => {
            cancelled = true;
            reject(new AdminMfaCancelledError());
          },
        },
      }),
    ),
  ).finally(() => {
    pending = null;
  });
  return pending;
}
